import React, {useEffect} from 'react'
import {HomeStage} from '../modules/HomeStage'
import isEmpty from 'lodash.isempty'
import {Filters} from '../modules/Filters'
import {Results} from '../modules/Results'
import {Loading} from '../components/Loading'
import {useSelector} from 'react-redux'
import {RootState} from '../rootReducer'
import {Breakpoints} from '@volkswagen-onehub/components-core'
import styled from 'styled-components'
import {NoSimulations} from '../components/NoSimulations'
import {closeLayers} from '../../shared/utilities'
import {setTrackingServiceManager} from '../../shared/trackingServiceHelper'
import {useFeatureServices} from '../../use-feature-services'

const ContentContainer = styled.div`
    padding: 0 ${(props) => props.theme.size.grid002};

    @media (min-width: ${Breakpoints.b560}px) {
        padding: 0 ${(props) => props.theme.size.grid001};
    }

    @media (min-width: ${Breakpoints.b1280}px) {
        padding: 0 ${(props) => props.theme.size.grid002};
    }

    @media (min-width: ${Breakpoints.b1600}px) {
        padding: 0 ${(props) => props.theme.size.grid003};
    }

    @media (min-width: ${Breakpoints.b1920}px) {
        padding: 0 ${(props) => props.theme.size.grid005};
    }

    @media (min-width: 2300px) {
        padding: 0 ${(props) => props.theme.size.grid006};
    }

    @media (min-width: ${Breakpoints.b2560}px) {
        padding: 0 ${(props) => props.theme.size.grid006};
    }

    @media (min-width: 3000px) {
        padding: 0 ${(props) => props.theme.size.grid007};
    }
`

export function Home(): React.JSX.Element {
    const {tracking: trackingManager} = useFeatureServices() as any

    const modelsByPromotions = useSelector(
        (state: RootState) => state.configurationModelsData.modelsByPromotions
    )

    const loading = useSelector((state: RootState) => state.general.loading)

    useEffect(() => {
        setTrackingServiceManager(trackingManager)
        closeLayers()
    }, [])

    return (
        <>
            <HomeStage></HomeStage>
            {loading ? (
                <Loading />
            ) : (
                <ContentContainer>
                    {!isEmpty(modelsByPromotions) ? (
                        <>
                            <Filters></Filters>
                            <Results></Results>
                        </>
                    ) : (
                        <NoSimulations />
                    )}
                </ContentContainer>
            )}
        </>
    )
}
